import React from 'react';

/**
 * Reusable toolbar wrapper for search + filters.
 * @param {React.ReactNode} left - Left side content (search bar)
 * @param {React.ReactNode} right - Right side content (filters)
 * @param {string} className - Additional class
 */
const Toolbar = ({ left, right, className = '' }) => {
  return (
    <div className={`toolbar ${className}`}>
      <div className="toolbar__left">{left}</div>
      <div className="toolbar__right">{right}</div>
    </div>
  );
};

export default Toolbar;
